export const StarOutlineIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2093 4.01092L12.4412 6.49501C12.6092 6.84081 13.0571 7.17249 13.4351 7.236L15.6678 7.61002C17.0957 7.84997 17.4317 8.89442 16.4028 9.92475L14.667 11.6749C14.373 11.9713 14.212 12.5429 14.303 12.9522L14.8 15.1187C15.1919 16.8336 14.289 17.497 12.7842 16.6007L10.6914 15.3516C10.3135 15.1258 9.69053 15.1258 9.30553 15.3516L7.21279 16.6007C5.71495 17.497 4.80505 16.8265 5.19701 15.1187L5.69395 12.9522C5.78494 12.5429 5.62396 11.9713 5.32999 11.6749L3.59419 9.92475C2.5723 8.89442 2.90126 7.84997 4.3291 7.61002L6.56186 7.236C6.93281 7.17249 7.38076 6.84081 7.54874 6.49501L8.7806 4.01092C9.45253 2.66303 10.5444 2.66303 11.2093 4.01092Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
